import { TankPlanInsideWrapper } from './TankPlanViewer.styles';
import { useStowageStore } from 'src/context/StowageContext';
import TankPlanView from './TankPlanView';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';

const TankPlanPdfReportContainer: React.FC = () => {
    const { tankplanViewWidth, reportTankPlanCondition } = useStowageStore();
    const { filterTanksForReport } = useStowageSelectionStore();

    return (
        <TankPlanInsideWrapper
            containerWidth={tankplanViewWidth}
            id="tankPlanPdfReportContainer"
            style={{
                fontSize: '1rem',
                position: 'absolute',
                zIndex: -1,
                top: '50px',
                left: '63px',
                width: '1920px',
                height: '1080px',
                background: 'white',
            }}
        >
            {reportTankPlanCondition && (
                <TankPlanView tankPlanCondition={reportTankPlanCondition} isReport={true} filterTanksForReport={filterTanksForReport} />
            )}
        </TankPlanInsideWrapper>
    );
};

export default TankPlanPdfReportContainer;
